<template>
  <div
    id="edit-sendout"
  >
    
    <div>
      <memlist-card :class="{ 'card-error': !basic_settings_ok && error }">
        <h5 class="mb-1 mt-4">
          <span :class="`svg-icon svg-icon-sm mr-2 text-${(!basic_settings_ok) ? 'danger' : 'success'}`">
            <inline-svg
              :src="(!basic_settings_ok) ? '/assets/svg/x-circle.svg' : '/assets/svg/check-circle.svg'"
            ></inline-svg>
          </span>
          {{$t('SENDOUT.BASIC_SETTINGS')}}
        </h5>
      
        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-text-input
              id="input-sendout_id"
              v-model="local_item.sendout_id"
              :title="'ID'"
              type="text"
              disabled
            />

          </m-col>
        </m-row>
          
        <m-row class="mt-4">
          <m-col md="5">
            <memlist-text-input
              id="input-1"
              layout="vertical"
              v-model="local_item.name"
              :title="$t('PAGES.SENDOUT.NAME_ON_SENDOUT')"
              type="text"
              :placeholder="$t('PAGES.SENDOUT.NAME_ON_SENDOUT')"
              class="flex-fill mr-4"
            />
          </m-col>

          <m-col md="2">
            <memlist-select-input2
              id="input-type"
              layout="vertical"
              :items="types"
              v-model="local_item.type"
              :title="$t('PAGES.SENDOUT.TYPE')"
              class="flex-fill mr-4"
            />
          </m-col>

          <m-col md="5">
            <memlist-select-input2
              id="input-prio"
              layout="vertical"
              v-model="local_item.prio"
              :items="PRIO_OPTIONS"
              :title="'Prioritering'"
              class="flex-fill"
            />
          </m-col>
        </m-row>

      </memlist-card>
      
      <memlist-card :class="{ 'card-error': !template_ok && error }" v-if="local_item.type === 'email'" class="mt-4">
        <SendoutEmail
          :item="local_template_select"
          ref="sendout-email"
          @update:item="on_template_updated"
          @validation="validation_template"
          @create_template_clicked="create_template_clicked"
        />
      </memlist-card>
      
      <memlist-card :class="{ 'card-error': !template_ok && error }" v-if="local_item.type === 'sms'" class="mt-4">
        <SendoutSMS
          :item="local_template_select"
          ref="sendout-sms"
          class="mt-8"
          @update:item="on_template_updated"
          @validation="validation_template"
          @create_template_clicked="create_template_clicked"
        />
      </memlist-card>
      

      <memlist-card class="mt-4">

        <m-row class="mt-8">
          <m-col lg="12">
            <QuestionRadioOptions
              group="schedule-radio"
              :item="schedule_options"
              :preselected="active_schedule_value"
              @selected="schedule_option_changed"
            />
          </m-col>
        </m-row>

        <div class="mt-4" v-if="active_scheduled_at">

          <m-row >
            
            <m-col>
              
              <memlist-datetime-picker
                :title="$t('SENDOUT.SCHEDULED_AT')"
                v-model="local_item.scheduled_at"
              >
              </memlist-datetime-picker>
              
            </m-col>
          </m-row>
          <p class="mt-2">{{ $t('PAGES.SENDOUT.SCHEDULED_AT_HELPTEXT') }}</p>
        </div>
        
        </memlist-card>

        <memlist-card class="mt-4" :class="{ 'card-error': (local_item.num_to_send === 0 || !local_item.num_to_send) && error }">
          <!-- inside the <memlist-card> where you make the recipient selection -->
          <h5 class="mb-1 mt-4">
            <span
              :class="`svg-icon svg-icon-sm mr-2 text-${(local_item.num_to_send === 0 || !local_item.num_to_send) ? 'danger' : 'success'}`"
            >
              <inline-svg
                :src="(local_item.num_to_send === 0 || ! local_item.num_to_send)
                  ? '/assets/svg/x-circle.svg'
                  : '/assets/svg/check-circle.svg'"
              />
            </span>
            {{ $t('PAGES.SEARCH.MAKE_SELECTION') }}
          </h5>

          <m-row class="mt-4">
            <m-col lg="6">

              <memlist-card style="height: 176px;">
                <p><b>{{ $t('SENDOUT.OPTION1') }}:</b> {{ $t('SENDOUT.SELECT_AUDIENCE') }}</p>
                <p style="font-style: italic;">{{ $t('SENDOUT.SELECT_AUDIENCE_INFO') }}</p>
                <memlist-select-input2
                  v-model="selectedListId"
                  :items="audience_options"
                  layout="vertical"
                  :title="$t('SENDOUT.SELECT_AUDIENCE')"
                  class="mt-8"
                  @input="selected_contact_list"
                />
              </memlist-card>

              
            </m-col>
            <m-col lg="6">
              <memlist-card style="height: 176px;">
                <p><b>{{ $t('SENDOUT.OPTION2') }}:</b> {{ $t('SENDOUT.SELECT_SEARCH') }}</p>
                <memlist-button
                  @click="open_select_search_modal"
                  variant="outline-primary"
                  class="mt-8"
                  style="max-width: 250px;"
                >
                  {{ $t('SENDOUT.SELECT_SEARCH') }}
                </memlist-button>
              </memlist-card>

            </m-col>
          </m-row>

          <m-row class="mt-4">
            <m-col lg="12">

              <p class="mt-3">
                <b>{{ $t('SENDOUT.NUM_RECIPIENTS') }}:</b>
                {{ recipients_count }}
              </p>
            </m-col>
          </m-row>

          <AdvancedSearchEditorModal
            ref="advanced-search-member-editor-modal"
            :search_options="local_item.search_options"
            @selected_search_options="selected_search_options"
            @cancel="()=>{this.$refs['advanced-search-member-editor-modal'].hide();}"
          />


        </memlist-card>


    </div>
    
    <m-row class="mt-4" v-if="error">
      <m-col lg="6"></m-col>
      <m-col lg="6">
        <span class="validation-error">{{ error }}</span>
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="12">
        <div class="d-flex justify-end">
          <memlist-icon-button
            class="mr-2 mt-4"
            icon="fa fa-play"
            :text="$t('SENDOUT.START')"
            variant="success"
            
            @click="start_clicked"
          />
          
          <memlist-button class="mt-4" ref="save-button" @click="on_save_sendout" variant="primary">{{ $t('COMMON.SAVE') }}</memlist-button>
        
        </div>
        
      </m-col>
    </m-row>
    <TemplateEditorModal
      :type="type"
      source="sendout"
      ref="template-editor-modal"
      @created="created_template"
    />
  </div>
</template>

<script>
import AdvancedSearchEditorModal from '@/view/pages/ml/advanced_search/AdvancedSearchEditorModal.vue';
import SendoutEmail from '@/view/pages/ml/sendout/SendoutEmail.vue';
import SendoutSMS from '@/view/pages/ml/sendout/SendoutSMS.vue';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import QuestionRadioOptions from '@/view/components/questions/QuestionRadioOptions.vue';
import axios from 'axios';
import TemplateEditorModal from '@/view/pages/ml/templates/TemplateEditorModal.vue';

export default {
  name: 'SendoutEditor',
  components: {
    RightSaveButton,
    SendoutSMS,
    SendoutEmail,
    AdvancedSearchEditorModal,
    QuestionRadioOptions,
    TemplateEditorModal,
  },
  props: ['item'],
  emits: ['create', 'update', 'start'],
  data() {
    return {
      template: {},
      type: null,
      template_ok: null,
      error: null,

      local_template_select: {},

      audiences: [],
      audience_options: [],
      selectedListId: null,
      

      active_scheduled_at: false,
      local_item: {},
      types: [
        { value: 'email', text: this.$t('MEMBER.EMAIL') },
        { value: 'sms', text: 'SMS' }
      ],
      PRIO_OPTIONS: [
        { value: 'sys', text: this.$t('PAGES.SENDOUT.SYS') },
        { value: 'imp', text: this.$t('PAGES.SENDOUT.IMP') },
        { value: 'def', text: this.$t('PAGES.SENDOUT.DEF') },
      ],
    }
  },
  computed: {

    allOk() {
      return this.basic_settings_ok && this.recipients_count > 0 && this.local_item.template_id;
    },
    basic_settings_ok() {
      return this.local_item.name && this.local_item.name.length > 1;
    },
    schedule_options() {
      return {
        name: this.$t('SENDOUT.SCHEDULE_OPTION'),
        options: [ 
          { value: 'DIRECT', text: this.$t('SENDOUT.DIRECT') }, 
          { value: 'SCHEDULED', text: this.$t('SENDOUT.SCHEDULED') } 
        ]
      }
    },
    active_schedule_value() {
      if (this.active_schedule_at) {
        return 'SCHEDULED';
      }

      return 'DIRECT';
    },
    recipients_count() {
      return this.local_item.num_to_send || 0;
    }
  },
  
  watch: {
    allOk() {
      if (this.allOk) {
        this.error = null;
      }
    },
    'local_item.scheduled_at'() {
      if (this.local_item.scheduled_at) {
        this.active_scheduled_at = true;
      }
    },
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        if (this.item) {
          this.local_item = {...this.item };

          if (this.local_item && this.local_item.search_options && this.local_item.search_options.audience_id) {
            this.selectedListId = this.local_item.search_options.audience_id;
          }

          this.local_template_select = JSON.parse(JSON.stringify(this.local_item));
        }
      },
      immediate: true
    },
  },
  async mounted() {
    await this.load_audiences();

  },
  methods: {
    created_template(item) {},
    create_template_clicked(type) {
      this.type = type;
      this.template = {
        is_email: this.type === 'EMAIL',
        is_sms: this.type === 'SMS',
      };
      this.$refs['template-editor-modal'].show();
    },
    validation_template(template_ok) {
      this.template_ok = template_ok;
    },
    async load_audiences() {
      this.audience_options = [];
      const res = await axios.get(`/audience`);

      if (res.status === 200) {

        this.audiences = res.data;
        
        this.audience_options = res.data.map(i => ({ text: i.name + ` (${i.count_members + i.count_users})`, value: i.id }));
        
      }
      
    },


    start_clicked() {
      if (!this.allOk) {
        this.error = this.$t('SENDOUT.FORM_NOT_VALID');
        return;
      }
      
      this.error = null;

      this.$emit('start', this.local_item);
    },
    schedule_option_changed(value) {
      this.active_scheduled_at = value === 'SCHEDULED';
    },
    toggle_active_schedule_at() {
      const target = !this.active_scheduled_at;

      if (!target) {
        this.local_item.scheduled_at = null;
      }
    },
    open_select_search_modal() {
      this.$refs['advanced-search-member-editor-modal'].show();
    },

    selected_contact_list(value) {

      const audience = this.audiences.find(i => i.id === value);

      if (audience) {
        this.local_item.num_to_send = audience.count_members + audience.count_users;
        
        this.local_item.search_options = {
          audience_id: audience.id,
          source: 'SENDOUT',
          entity_type: 'MEMBER',
          is_sendout: true,
        };
      }

      this.local_item = {...this.local_item };
    },
      
    selected_search_options(search_options, count) {
      
      this.local_item.search_options = search_options;
      this.local_item.num_to_send = count;
      this.selectedListId = null;

      this.$refs['advanced-search-member-editor-modal'].hide();
    },

    on_save_sendout() {
      if (this.local_item.sendout_id) {
        this.$emit('update', this.local_item);
      }
      else {
        this.$emit('create', this.local_item);
      }
    },
    on_item_updated(item) {
      this.local_item = { ...item };
    },
    on_template_updated(data) {
      //this.local_template_select = data;
      this.local_item.template_id = data.template_id;
      this.local_item.overrides = data.overrides;
    }
  },
  
}
</script>

<style lang="css" scoped>
/* extra tweaks for the inline “Eller” spacer */
.or-spacer {
  font-weight: 500;
  color: #6c757d;
  white-space: nowrap;
}

/* let the row breathe on small screens */
@media (max-width: 991.98px) {
  .select-or-search .or-spacer {
    width: 100%;
    text-align: center;
    margin: 0 0 .5rem;
  }
}

.validation-error {
  color: red;
}

.card-error { 
  border: 1px solid red;
}

</style>